import type React from 'react'

import { SelectSeparator } from '@radix-ui/react-select'

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/atoms/Select'
import { type Region } from '@/state/regions/types'

export const GLOBAL_SELECTOR_VALUE = '__global__'

export interface RegionSelectorProps {
  regions: Region[]
  selectedRegionId?: string // undefined means "all"
  showGlobalOption?: boolean
  onRegionChange: (regionId: string | undefined) => void
}

export const RegionSelector: React.FC<RegionSelectorProps> = ({
  regions,
  selectedRegionId,
  showGlobalOption = false,
  onRegionChange,
}) => (
  <Select
    value={selectedRegionId ?? 'all'}
    onValueChange={(value) => {
      onRegionChange(value === 'all' ? undefined : value)
    }}>
    <SelectTrigger className="w-fit">
      <SelectValue placeholder="region" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem key="all" value="all">
          All
        </SelectItem>
        {showGlobalOption && (
          <SelectItem key="global" value={GLOBAL_SELECTOR_VALUE}>
            Global
          </SelectItem>
        )}
      </SelectGroup>
      <SelectSeparator />
      <SelectGroup>
        {regions.map((region) => (
          <SelectItem key={region._id} value={region._id}>
            {region.name}
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
)
